import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useMemo,
} from "react";
import { FaSearch } from "react-icons/fa";
import Cookies from "js-cookie";
import { getFreshAccessToken } from "../chat/api";
import api from "../chat/api";
import { useNavigate } from "react-router-dom";
import { Header } from "../../components/Header/Header";
import UploadModal from "../Contract/UploadModal";
import Filter_for_ocr from "../Ocr_Data/Filter_for_ocr";
import bell from "../../Images/ai-bell.png";
import search from "../../Images/search-big.jpg";
import axios from "axios";
import "../Contract/contract_data.css";
import Spinner from "../Contract/Spinner";
import CustomDropdown from "../Contract/CustomDropdown";
import useGooglePicker from "../Ocr_Data/useGooglePicker";
import { toast } from "../../utils/appToast";
const ContractTable = ({isMenuOpen}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isBulkDelete, setIsBulkDelete] = useState(false);
  const [exportInProgress, setExportInProgress] = useState(false);
  const [invoices, setinvoices] = useState([]);
  const [token, setToken] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isActionMenuOpen, setIsActionMenuOpen] = useState(null);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [editContractId, setEditContractId] = useState(null);
  const [editedContractData, setEditedContractData] = useState({});
  const [loading, setLoading] = useState(false);
  const editRowRef = useRef(null);
  const [selectedinvoices, setSelectedinvoices] = useState([]);
  const [selectedContractKeys, setSelectedContractKeys] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupTitle, setPopupTitle] = useState("");
  const [popupMessage, setPopupMessage] = useState("");
  const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
  const [contractToDelete, setContractToDelete] = useState(null);
  const actionMenuRef = useRef(null);
  const [hoveredRow, setHoveredRow] = useState(null);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [filterType, setFilterType] = useState("");
  const [timeRange, setTimeRange] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
    const [file, setFile] = useState(null);
  const fileInputRef = useRef(null);
  const [selectedFilePreview, setSelectedFilePreview] = useState(null);
const { isConnected, connect, disconnect, openPicker, accessToken } = useGooglePicker();
const [hasOpenedPickerOnce, setHasOpenedPickerOnce] = useState(false);
const [isHovered, setIsHovered] = useState(false);

  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [hoveredAction, setHoveredAction] = useState(null);
  const [clickedAction, setClickedAction] = useState(null);
  const [invoice_name, setInvoiceName] = useState("");
const [actionMenuPosition, setActionMenuPosition] = useState({ top: 0, left: 0, openUpwards: false });
const [deleteInProgress, setDeleteInProgress] = useState(false);
const [renameSuccessRowId, setRenameSuccessRowId] = useState(null);
const[isCustomApplyFieldModal,setIsCustomApplyFiledModal] =useState(false);
const [customFieldsLoading, setCustomFieldsLoading] = useState(false);
const [isCustomFieldModalOpen, setIsCustomFieldModalOpen] = useState(false);
const [selectedTab, setSelectedTab] = useState("manage");
const [fieldName, setFieldName] = useState("");
const [fieldPrompt, setFieldPrompt] = useState("");
const [customFields, setCustomFields] = useState([]);
const [loadingAddField, setLoadingAddField] = useState(false);
const [deletingField, setDeletingField] = useState(null);
const isMaxFieldsReached = customFields.length >= 5;
const isFilled = fieldName.trim() && fieldPrompt.trim();
const [fieldCreationSuccess, setFieldCreationSuccess] = useState(false);
const moreButtonRef = useRef(null);
const [dropdownCoords, setDropdownCoords] = useState({ top: 0, left: 0 });
const [isCreatingNew, setIsCreatingNew] = useState(false);
const [selectedField, setSelectedField] = useState('');
const [newFieldName, setNewFieldName] = useState('');
const [newPrompt, setNewPrompt] = useState('');
const baseColumns = 7; // name, party A, party B, date, etc.
const totalColumns = baseColumns + customFields.length;
const uploadButtonRef = useRef(null);

const [tooltipCoords, setTooltipCoords] = useState({ top: 0, left: 0 });

const [customFieldPopup, setCustomFieldPopup] = useState({
  visible: false,
  value: '',
  contractKey: '',
  contractId: '',
  x: 0,
  y: 0,
});
const popupRef = useRef(null);
const minWidthPercent = totalColumns * 15; // e.g., 9 * 15 = 135
const [isLoading, setIsLoading] = useState(false);
    const handleFileChange = (event) => {
const selectedFiles = Array.from(event.target.files || []);
console.log("📁 Files selected in Spreadsheet_data:", selectedFiles);
if (selectedFiles.length === 0) return;

setFile(selectedFiles); // ✅ save to state
setIsModalOpen(true);
};
  const [filterApplied, setFilterApplied] = useState(false);
  const navigate = useNavigate();
  const handleFilterApply = (filteredInvoices, filterData) => {
    setinvoices(filteredInvoices);
    setIsFilterApplied(true);
    setFilterType(filterData.filterType);
    setTimeRange(filterData.timeRange);
    setFromDate(filterData.fromDate);
    setToDate(filterData.toDate);
    toggleFilterModal();
  };
  const [filteredFiles, setFilteredFiles] = useState([]);

const [selectedFilters, setSelectedFilters] = useState({
  passport: false,
  id: false,
  visa: false,
  license: false,
});




useEffect(() => {
  if (isConnected && !hasOpenedPickerOnce) {
    // Don't open picker here
    setHasOpenedPickerOnce(true);
  }
}, [isConnected, hasOpenedPickerOnce]);
const handleAddFromDriveClick = () => {
  openPicker(async (docs) => {
    console.log("📄 Files picked:", docs);

    try {
      const files = await Promise.all(
        docs.map(async (doc) => {
          const res = await fetch(`https://www.googleapis.com/drive/v3/files/${doc.id}?alt=media`, {
            headers: { Authorization: `Bearer ${accessToken}` },
          });

          if (!res.ok) throw new Error("Failed to fetch file from Drive");

          const blob = await res.blob();
          return new File([blob], doc.name, { type: blob.type });
        })
      );

      setFile(files); // 👈 trigger your upload flow
      setIsModalOpen(true); // 👈 open modal
    } catch (err) {
      console.error("Failed to process selected files", err);
      toast.error("Something went wrong while processing selected files.");
    }
  });
};



useEffect(() => {
const cookieToken = Cookies.get("access_token");
if (cookieToken) {
  setToken(cookieToken);
} else {
  console.error("Access token missing from cookies");
}
}, []);

  const toggleModal = () => {
   
    setIsModalOpen((prev) => !prev);
  };

    const handleConnectGoogleDrive = async () => {
    try {
      console.log("🔄 Attempting to connect to Google Drive...");
  const token = await getFreshAccessToken();
      if (!token) throw new Error("No access token found");
  const response = await axios.get(`http://localhost:8000/api/auth/google-drive/`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

      
      console.log("✅ Response from backend:", response);

    if (response.data && response.data.auth_url) {
        const fixedRedirectUrl = response.data.auth_url.replace(
          "http%3A%2F%2Flocalhost%3A8000%2Fapi%2Fauth%2Fgoogle-drive%2Fcallback%2F",
          encodeURIComponent("https://stagingbackend.docusensa.com/api/auth/google-drive/callback/")
        );

        console.log("🚀 Redirecting to fixed URL:", fixedRedirectUrl);
        window.location.href = fixedRedirectUrl;
      } else {
        console.warn("⚠️ auth_url not found in response");
        showPopup("Error", "Invalid response from server.");
      }
    } catch (error) {
      console.error("❌ Failed to connect Google Drive", error);

      if (error.response) {
        console.error("📡 Server responded with error:", error.response.status, error.response.data);
      } else if (error.request) {
        console.error("📭 No response received:", error.request);
      } else {
        console.error("💥 Error setting up request:", error.message);
      }

      showPopup("Error", "Failed to connect Google Drive. Please try again.");
    }
  };



  const handleExport = async () => {
    

    if (!selectedinvoices || selectedinvoices.length === 0) {
      showPopup("Error", "Please select at least one invoice to export.");
      return;
    }

    setExportInProgress(true);

    try {
      const response = await api.post(
        `api/v1/idsocr/export-id/`,
        { id_keys: selectedContractKeys },
        { responseType: "blob" }
      );
      

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "invoices_export.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // showPopup("Success", "Invoices exported successfully.");
      setSelectedinvoices([]);
setSelectedContractKeys([]);
setIsBulkDelete(false);
    } catch (error) {
      if (error.response) {
        const message =
          error.response.data?.msg || "Failed to export invoices.";
        showPopup("Error", message);
      } else {
        showPopup("Error", "An unexpected error occurred. Please try again.");
      }
    } finally {
      setExportInProgress(false);
    }
  };

  const handleCancel = () => {
    setSelectedinvoices([]);

    setIsModalOpen(false);
    setIsFilterModalOpen(false);
    setPopupVisible(false);

    setConfirmDeleteVisible(false);
  };
const handleToggleMore = () => {
  if (isActionMenuOpen === "more") {
    setIsActionMenuOpen(null);
  } else {
    const rect = moreButtonRef.current.getBoundingClientRect();
    setDropdownCoords({
      top: rect.bottom + window.scrollY + 6,  // Add spacing
      left: rect.left + window.scrollX,       // Align horizontally
    });
    setIsActionMenuOpen("more");
  }
};

 const handleDeleteField = async (fieldId) => {
  try {
await api.delete(`/api/v1/idsocr/delete-field/${fieldId}/`);
    await fetchCustomFields(); // refresh after deletion
  } catch (error) {
    console.error("Error deleting field", error);
  } finally {
    setDeletingField(null);
  }
};


const handleAddField = async () => {
  if (!fieldName.trim() || !fieldPrompt.trim()) return;
  try {
    setLoadingAddField(true);
    await api.post("/api/v1/idsocr/create-field/", {

      field: fieldName.trim(),
      description: fieldPrompt.trim(),
    });

    setFieldName("");
    setFieldPrompt("");
    await fetchCustomFields();
    await fetchinvoices();
    // show inline success message near button
    setFieldCreationSuccess(true);

    setTimeout(() => setFieldCreationSuccess(false), 3000);
    setSelectedTab("manage");
    setIsCustomFieldModalOpen(false);
  } catch (error) {
    console.error("Error adding field", error);
  } finally {
    setLoadingAddField(false);
  }
};

  const fetchinvoices = useCallback(async () => {
    if (!token) return;
    setLoading(true);
  
    try {
      let url = `api/v1/idsocr/ids/`;

      if (isFilterApplied) {
        url = `api/v1/invoice/filter-invoice/`;
  
        const params = {
          filter_type: filterType,
          time_range: timeRange,
          from_date: fromDate,
          to_date: toDate,
        };
  
        const response = await api.get(url, { params });
        setinvoices(response.data.invoices || []);
      } else {
        const response = await api.get(url); // clean, no headers needed
        setinvoices(response.data);
      }
    } catch (error) {
      console.error("Error fetching invoices:", error);
    } finally {
      setLoading(false);
    }
  }, [token, isFilterApplied, filterType, timeRange, fromDate, toDate]);
  
  

  const tableBodyRef = useRef(null);

  const scrollToTop = () => {
    if (tableBodyRef.current) {
      tableBodyRef.current.scrollTop = 0;
    }
  };

  const handleSelectAll = () => {
    if (selectedinvoices.length === invoices.length) {
      setSelectedinvoices([]);
      setSelectedContractKeys([]);
    } else {
      setSelectedinvoices(invoices.map((contract) => contract.id));
      setSelectedContractKeys(invoices.map((contract) => contract.key));
    }
  };

const filteredinvoices = useMemo(() => {
  const query = searchQuery?.toLowerCase() || "";
  return (invoices || []).filter((invoice) => {
    const invoiceName = invoice?.name?.toLowerCase() || ""; 
    const customerName = invoice?.details?.["Customer name"]?.toLowerCase() || "";
    const vendorName = invoice?.details?.["Vendor name"]?.toLowerCase() || "";

    return (
      invoiceName.includes(query) ||
      customerName.includes(query) ||
      vendorName.includes(query)
    );
  });
}, [invoices, searchQuery]);



  const indexOfLastContract = currentPage * rowsPerPage;
  const indexOfFirstContract = indexOfLastContract - rowsPerPage;
  const currentinvoices = useMemo(() => {
    const indexOfLastContract = currentPage * rowsPerPage;
    const indexOfFirstContract = indexOfLastContract - rowsPerPage;
    return filteredinvoices.slice(indexOfFirstContract, indexOfLastContract);
  }, [filteredinvoices, currentPage, rowsPerPage]);

  const totalPages = useMemo(
    () => Math.ceil(filteredinvoices.length / rowsPerPage),
    [filteredinvoices, rowsPerPage]
  );
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const handleCheckboxChange = (id, key) => {
    if (selectedinvoices.includes(id)) {
      setSelectedinvoices(
        selectedinvoices.filter((contractId) => contractId !== id)
      );
      setSelectedContractKeys(
        selectedContractKeys.filter((contractKey) => contractKey !== key)
      );
    } else {
      setSelectedinvoices([...selectedinvoices, id]);
      setSelectedContractKeys([...selectedContractKeys, key]);
    }
  };



  const tbodyRef = useRef(null);
     useEffect(() => {
  const calculateRowsPerPage = () => {
    if (tbodyRef.current) {
      const containerHeight = tbodyRef.current.clientHeight;

      const headerHeight = 52; // height of the <thead> row (approx)
      const rowHeight = 44;    // your row height from <tr className="h-[44px]">

      const visibleHeight = containerHeight - headerHeight;
      const calculatedRows = Math.floor(visibleHeight / rowHeight);

      if (calculatedRows > 0) {
        setRowsPerPage(calculatedRows);
      }
    }
  };

  calculateRowsPerPage(); // On mount

  window.addEventListener("resize", calculateRowsPerPage); // On resize

  return () => window.removeEventListener("resize", calculateRowsPerPage);
}, []);

  useEffect(() => {
    if (token) {
      fetchinvoices();
    }
  }, [fetchinvoices, token, isFilterApplied, filterType, timeRange, fromDate, toDate]);

  useEffect(() => {
    if (isFilterApplied) {
      localStorage.setItem("invoiceFilter", JSON.stringify({ filterType, timeRange, fromDate, toDate }));
    }
  }, [isFilterApplied, filterType, timeRange, fromDate, toDate]);

  
  // useEffect(() => {
  //   const storedFilters = JSON.parse(localStorage.getItem("invoiceFilter"));
  //   if (storedFilters) {
  //     setFilterType(storedFilters.filterType);
  //     setTimeRange(storedFilters.timeRange);
  //     setFromDate(storedFilters.fromDate);
  //     setToDate(storedFilters.toDate);
  //     setIsFilterApplied(true);
  //   }
  // }, []);
  

  const handleUploadSuccess = () => {
    fetchinvoices();
    toggleModal();
  };

  const handleCloseModal = () => {
    toggleModal();
    fetchinvoices();
  };

  const handlePageChange = (event) => {
    const newPage = Number(event.target.value);
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

 const toggleActionMenu = (index, event) => {
const menuHeight = 150; // Approximate height of the action menu
const rect = event.currentTarget.getBoundingClientRect();
const bottomSpace = window.innerHeight - rect.bottom;

const openUpwards = bottomSpace < menuHeight;

setIsActionMenuOpen(isActionMenuOpen === index ? null : index);
setActionMenuPosition({
top: openUpwards ? rect.top - menuHeight : rect.bottom,
left: rect.left,
openUpwards,
});
};

  const toggleFilterModal = () => {
    setIsFilterModalOpen((prev) => !prev);
  };

const handleViewMore = (invoiceKey) => {
  navigate(`/Invoices/Invoice_Details/${invoiceKey}`);
};


  const enableEdit = (invoice) => {
    if (invoice) {
      setIsActionMenuOpen(null);
      setEditContractId(invoice.id);

      
const formatDateForInput = (dateString) => {
  if (!dateString) return "";

  // Handle DD-MM-YY or MM-DD-YY manually if needed
  const regex = /^(\d{1,2})[-/](\d{1,2})[-/](\d{2}|\d{4})$/;
  const match = dateString.match(regex);

  if (match) {
    let [_, part1, part2, part3] = match;

    // Ensure 4-digit year
    if (part3.length === 2) {
      part3 = parseInt(part3) < 50 ? "20" + part3 : "19" + part3;
    }

    // Try interpreting both ways
    const d1 = new Date(`${part3}-${part1}-${part2}`); // yyyy-mm-dd
    const d2 = new Date(`${part3}-${part2}-${part1}`); // yyyy-dd-mm

    // Pick the valid one
    if (!isNaN(d1.getTime()) && d1.getDate() == part2) {
      return d1.toISOString().split("T")[0];
    }
    if (!isNaN(d2.getTime()) && d2.getDate() == part1) {
      return d2.toISOString().split("T")[0];
    }
  }

  // Try Date object fallback
  const parsed = new Date(dateString);
  if (!isNaN(parsed.getTime())) {
    return parsed.toISOString().split("T")[0];
  }

  return ""; // fallback if all fails
};







      
      const extractAmountAndCurrency = (amount) => {
        if (!amount) return { value: "", currency: "" };

        const match = amount.toString().match(/^([\D]*)([\d,\.]+)$/); 
        if (match) {
          return {
            currency: match[1].trim(), 
            value: match[2].trim().replace(",", "."), 
          };
        }
        return { value: amount, currency: "" }; 
      };

      const { value, currency } = extractAmountAndCurrency(
        invoice.details?.["Total due amount"]
      );

      setEditedContractData({
        ...invoice,
        details: {
          ...invoice.details,
         "DOB": formatDateForInput(invoice.details?.["DOB"]),
    "Date of issue": formatDateForInput(invoice.details?.["Date of issue"]),
    "Date of expiry": formatDateForInput(invoice.details?.["Date of expiry"]),
    "Issued on": formatDateForInput(invoice.details?.["Issued on"]),
    "Due date": formatDateForInput(invoice.details?.["Due date"]),
    "Total due amount": value,
    Currency: currency,
        },
      });
      setInvoiceName(invoice.name || "");
    } else {
      setEditContractId(null);
      setEditedContractData({});
      setInvoiceName("");
    }
  };
useEffect(() => {
  fetchCustomFields(); // Fetch custom fields when component mounts
}, []);


const fetchCustomFields = async () => {
  try {
    setCustomFieldsLoading(true);
const res = await api.get("/api/v1/idsocr/list-field/");
    setCustomFields(res.data || []);
  } catch (err) {
    console.error("Error fetching fields", err);
  } finally {
    setCustomFieldsLoading(false);
  }
};

const handleApplyField = async () => {
  setIsLoading(true);

  const selectedFieldObj = customFields.find(
    (field) => field.field === selectedField
  );

  const payload = isCreatingNew
    ? {
        new_field: {
          field: newFieldName,
          description: newPrompt,
        },
        doc_keys: selectedContractKeys,
      }
    : {
       field_id: selectedFieldObj?.id,
      doc_keys: selectedContractKeys,
      };

  if (!isCreatingNew && !payload.field_id) {
    console.error("Invalid field selected.");
    setIsLoading(false);
    return;
  }

  try {
const res = await api.post("api/v1/idsocr/apply-field/", payload);
    console.log("Success:", res.data);
    setIsCustomApplyFiledModal(false);
    await fetchinvoices();
    await fetchCustomFields();

    setSelectedinvoices([]);
    setSelectedContractKeys([]);
  } catch (err) {
    console.error("Error:", err);
  } finally {
    setIsLoading(false);
  }
};

const handleEditChange = (fieldPath, value) => {
  if (fieldPath.startsWith("details._custom_fields.")) {
    const key = fieldPath.split(".")[2];
    setEditedContractData((prev) => ({
      ...prev,
      details: {
        ...prev.details,
        _custom_fields: {
          ...(prev.details?._custom_fields || {}),
          [key]: value,
        },
      },
    }));
  } else if (fieldPath.startsWith("details.")) {
    const key = fieldPath.split(".")[1];
    setEditedContractData((prev) => ({
      ...prev,
      details: {
        ...prev.details,
        [key]: value,
      },
    }));
  } else {
    setEditedContractData((prev) => ({
      ...prev,
      [fieldPath]: value,
    }));
  }
};


  const handleClickOutside = (event) => {
    if (
      actionMenuRef.current &&
      !actionMenuRef.current.contains(event.target)
    ) {
      setIsActionMenuOpen(null);
    }
    if (
      confirmDeleteVisible &&
      event.target.closest(".popup-overlay") === null &&
      !event.target.closest(".popup-box-delete")
    ) {
      setConfirmDeleteVisible(false);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [confirmDeleteVisible, isActionMenuOpen]);

  const showPopup = (title, message) => {
    setPopupTitle(title);
    setPopupMessage(message);
    setPopupVisible(true);
  };

  const closePopup = () => {
    setPopupVisible(false);
  };
  const handleDelete = (contractId) => {
    
    setIsActionMenuOpen(null);
    setIsBulkDelete(false);
    setContractToDelete(contractId);
    setConfirmDeleteVisible(true);
  };

  const handleBulkDelete = () => {
   

    if (!selectedinvoices || selectedinvoices.length === 0) {
      showPopup("Error", "Please select at least one contract to delete.");
      return;
    }
    setIsActionMenuOpen(null);
    setIsBulkDelete(true);
    setConfirmDeleteVisible(true);
  };

const handleEditSave = async (invoiceId, invoiceKey) => {
  const fields = editedContractData.details || {};

  const editedData = {
    "DOB": fields["DOB"],
    "Name": fields["Name"],
    "Date of issue": fields["Date of issue"],
    "Date of expiry": fields["Date of expiry"],
    "Type": fields["Type"],
    "Country": fields["Country"],
    "Id / Number": fields["Id / Number"],
    "Issuing Authority": fields["Issuing Authority"],
    "_custom_fields": fields["_custom_fields"] || {},
  };

  const payload = {
    edited_data: editedData,
  };

  // 🔥 Only add id_name if the name was changed
  if (invoice_name && invoice_name !== editedContractData.name) {
    payload.id_name = invoice_name;
  }

  try {
    const response = await api.post(
      `/api/v1/idsocr/edit-id-details/${invoiceKey}/`,
      payload
    );

    if (response.status === 200) {
      const updated = response.data.data;

      setinvoices((prev) =>
        prev.map((inv) =>
          inv.id === invoiceId
            ? { ...inv, name: invoice_name, details: updated }
            : inv
        )
      );

      setEditContractId(null);
      setRenameSuccessRowId(invoiceId);
      setTimeout(() => setRenameSuccessRowId(null), 3000);
    }
  } catch (error) {
    console.error("Edit failed:", error);
    showPopup("Error", "Failed to update ID. Please try again.");
  }
};


  const confirmDelete = async () => {
  

    const idsToDelete = isBulkDelete ? selectedinvoices : [contractToDelete];

    setDeleteInProgress(true);

    try {
      const response = await api.delete(`api/v1/idsocr/id-delete/`, {
data: { document_ids: idsToDelete },
});


      const { Deleted_invoices = [], Failed_deletions = [] } = response.data;

      if (Deleted_invoices.length > 0) {
        setinvoices((previnvoices) =>
          previnvoices.filter(
            (invoice) => !Deleted_invoices.includes(invoice.id)
          )
        );

        if (isBulkDelete) {
          setSelectedinvoices([]);
          setSelectedContractKeys([]);
        }

        
      }

      if (Failed_deletions.length > 0) {
        const failureMessages = Failed_deletions.map(
          (failure) => `Invoice ID ${failure.invoice_id}: ${failure.error}`
        ).join("\n");
        showPopup("Deletion Failed", failureMessages);
      }
    } catch (error) {
      console.error("Error deleting invoices:", error);
      showPopup("Error", "Failed to delete invoice(s). Please try again.");
    } finally {
       setDeleteInProgress(false);
setConfirmDeleteVisible(false);    // 👈 Close modal
setIsBulkDelete(false);            // 👈 Reset bulk delete flag
setContractToDelete(null);         // 👈 Clear single delete state
fetchinvoices();
    }
  };

  useEffect(() => {
    if (editContractId) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [editContractId]);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  return (
    <>
      {loading && <Spinner />}
      <div className="full-container max-w-full overflow-x-hidden">
        <div className="">
          <Header name="Identity Extraction" icon={""} isMenuOpen={isMenuOpen} />
        </div>

        <div className="contract-table-container  overflow-x-hidden"style={{ marginLeft: isMenuOpen ? "226px" : "120px" }}>
<div className="flex justify-between items-center contract-table-header overflow-x-hidden w-full pr-9 mt-[3px]">
  {/* LEFT: Search & Filter */}
  <div className="flex items-center gap-1 min-w-[300px]">
    {/* Search */}
   <div
  style={{
    display: 'flex',
    width: '310px',
    height: '40px',
    padding: '8px 20px 8px 26px', // ← increased left padding
    alignItems: 'center',
    gap: '1px',
    flexShrink: 0,
    borderRadius: '20px',
    border: isSearchFocused
      ? '1px solid rgba(187, 66, 174, 0.36)'
      : '1px solid rgba(0, 0, 0, 0.10)',
    backgroundColor: '#FFF',
    boxShadow: isSearchFocused
      ? '0px 11px 3px rgba(0, 0, 0, 0.00), 0px 7px 3px rgba(0, 0, 0, 0.01), 0px 4px 2px rgba(0, 0, 0, 0.05), 0px 2px 2px rgba(0, 0, 0, 0.09), 0px 0px 1px rgba(0, 0, 0, 0.10)'
      : 'none',
    overflow: 'hidden',
  }}
>
  <img
    src="/search.svg"
    alt="Search"
    style={{
      width: '24px',
      height: '24px',
      flexShrink: 0,
      marginRight: '4px', // ← extra spacing between icon and input
    }}
  />
  <input
    type="text"
    placeholder="Search Identity Here"
    value={searchQuery}
    onChange={(e) => setSearchQuery(e.target.value)}
    onFocus={() => setIsSearchFocused(true)}
    onBlur={() => setIsSearchFocused(false)}
    style={{
      fontFamily: 'Outfit, sans-serif',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: 'normal',
      border: 'none',
      outline: 'none',
      width: '100%',
      overflowX: 'auto',
      whiteSpace: 'nowrap',
      color: '#171717',
    }}
  />
</div>


    {/* Filter */}
   <button
                className={`filter-button-new ${
                  isFilterApplied ? "filter-applieds" : ""
                }`}
                onClick={toggleFilterModal}
              >
                <img
                  src={isFilterApplied ? "/Filter_CTA.png" : "/filter.svg"}
                  alt="Filter Icon"
                />
              </button>
  </div>

  {/* RIGHT: Custom field, Upload, Bulk Actions */}
  <div className="flex items-center gap-3 flex-wrap justify-end">
    {selectedinvoices.length > 0 ? (
      <>
        <span className="bg-[#F4EBFF] text-[#7F56D9] text-sm px-3 py-1 rounded-full font-medium">
          {selectedinvoices.length} Invoice selected
        </span>

       <button
    className="bg-[#7F56D9] text-white text-sm font-medium px-4 py-2 rounded-md hover:bg-[#6941C6] transition"
    onClick={() => setIsCustomApplyFiledModal(true)}
  >
    <span className="text-white">Apply Custom Field</span>
  </button>

        {/* More Dropdown */}
        <div className="relative">
          <button
            ref={moreButtonRef}
            onClick={handleToggleMore}
            className="border border-[#D0D5DD] text-[#344054] text-sm font-medium px-4 py-2 rounded-md flex items-center gap-2 hover:bg-gray-50"
          >
            More
            <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
              <path d="M19 9l-7 7-7-7" />
            </svg>
          </button>

      {isActionMenuOpen === "more" && (
  <div
    className="fixed z-[9999] w-35 bg-white border border-gray-200 rounded-md shadow-md py-1 p-1"
    style={{
      top: `${dropdownCoords.top}px`,
      left: `${dropdownCoords.left}px`,
    }}
  >
    {/* Export */}
    <button
      onClick={handleExport}
      disabled={exportInProgress}
      className="flex items-center gap-2 px-3 py-2 text-sm rounded-md w-full hover:bg-purple-100 text-[#8B55DD] disabled:opacity-50"
    >
      <img src="/export-icon-blue.svg" className="w-4 h-4" />
      {exportInProgress ? "Exporting..." : "Export"}
    </button>

    {/* Delete */}
    <button
      onClick={handleBulkDelete}
      className="flex items-center gap-2 px-3 py-2 text-sm rounded-md w-full hover:bg-red-100 text-red-600"
    >
      <img src="/delete-icon-red.svg" className="w-4 h-4" />
      Delete
    </button>
  </div>
)}

        </div>

        {/* Cancel */}
        <button onClick={handleCancel} className="ml-2">
          <img src="/cancel_icon.svg" alt="Cancel" className="w-5 h-5" />
        </button>
      </>
    ) : (
      <>
        <button
          className="flex items-center gap-2 px-4 py-2 bg-white new-custom-butons-design"
          onClick={() => setIsCustomFieldModalOpen(true)}
        >
          <img src="/custom-field-icons.svg" className="w-5 h-5" />
          <span className="new-custom-butons-design-text">Custom Field</span>
        </button>

  <div className="relative">
  <button
    ref={uploadButtonRef}
    className="flex items-center gap-2 px-4 py-2 bg-[#C95EBE] rounded-md text-white text-sm hover:bg-[#B34AB0]"
    onClick={() => setIsTooltipVisible(!isTooltipVisible)}
    onMouseEnter={() => {
      if (uploadButtonRef.current) {
        const rect = uploadButtonRef.current.getBoundingClientRect();
        setTooltipCoords({
          top: rect.top + window.scrollY + 45,
          left: rect.left + window.scrollX + rect.width - 140,
        });
      }
    }}
  >
    <img src="/upload_icon_white.svg" className="w-5 h-5" />
    <span className="new-custom-butons-design-texts">Upload</span>
  </button>

  {/* Tooltip dropdown with options */}
{isTooltipVisible && (
  <div
    className="fixed z-[9999] w-[188px] h-[102px] flex flex-col justify-center items-start gap-2 p-[10px] bg-white border border-black/20 rounded-[12px] shadow-[90px_417px_119px_rgba(0,0,0,0),58px_267px_109px_rgba(0,0,0,0.01),33px_150px_92px_rgba(0,0,0,0.05),14px_67px_68px_rgba(0,0,0,0.09),4px_17px_38px_rgba(0,0,0,0.10)]"
    style={{
      top: `${tooltipCoords.top + 10}px`,
      left: `${tooltipCoords.left - 50}px`,
    }}
    onMouseLeave={() => setIsTooltipVisible(false)}
  >
    {/* Upload from Device */}
    <div
      className="flex items-center gap-2 px-3 py-1.5 rounded-[9px] text-[#73607B] font-medium text-[16px] hover:bg-[#8B55DD]/20 hover:text-[#8B55DD] cursor-pointer transition-all"
      onClick={() => {
        setIsTooltipVisible(false);
        fileInputRef.current.click();
      }}
    >
      <img src="/upload-icon.svg" alt="Upload" className="w-4 h-4" />
      Add from device
    </div>

    {/* Connect Google Drive */}
    {!isConnected && (
      <div
        className="flex items-center gap-2 px-3 py-1.5 rounded-[9px] text-[#73607B] font-medium text-[16px] hover:bg-[#8B55DD]/20 hover:text-[#8B55DD] cursor-pointer transition-all"
        onClick={() => {
          setIsTooltipVisible(false);
          navigate("/account/integration");
        }}
        onMouseEnter={() => setIsHovered(true)}
    onMouseLeave={() => setIsHovered(false)}
      >
 <img
      src={isHovered ? "/connect-icon-hover.svg" : "/connect-icon.svg"}
      alt="Open Picker"
      className="w-4 h-4 transition-all duration-150"
    />        Connect Drive
      </div>
    )}

  {isConnected && (
  <div
    className="flex items-center gap-2 px-3 py-1.5 rounded-[9px] text-[#73607B] font-medium text-[16px] hover:bg-[#8B55DD]/20 hover:text-[#8B55DD] cursor-pointer transition-all"
    onMouseEnter={() => setIsHovered(true)}
    onMouseLeave={() => setIsHovered(false)}
    onClick={handleAddFromDriveClick} // Trigger the picker on click
  >
    <img
      src={isHovered ? "/picker-icon-hover.svg" : "/picker-icon.svg"}
      alt="Open Picker"
      className="w-4 h-4 transition-all duration-150"
    />
    Add from Drive
  </div>
)}
  </div>
)}


  <input
    ref={fileInputRef}
    type="file"
    multiple
    className="hidden"
    accept=".pdf,.jpeg,.jpg,.png"
    onChange={handleFileChange}
  />
</div>


      </>
    )}
  </div>
</div>

           <div
        className={`overflow-x-auto  transition-all duration-300 mt-2`}
        style={{
          width: isMenuOpen ? "calc(100vw - 320px)" : "calc(100vw - 158px)",
        }}
      >
    <div className="overflow-x-auto w-[100%]  mb-4">
      
      <div className="relative overflow-x-auto  custom-scrollbar-container"  style={{
        height: "calc(100vh - 180px)", // Adjust height as needed
    }}
    ref={tbodyRef}>
<table
  className="text-sm text-left table-auto"
  style={{ minWidth: `${totalColumns * 14.29}%` }}
>
              <thead className="bg-[#FFF] h-[51px] text-[#1E1E1E] font-medium border-b border-[rgba(0,0,0,0.10)]">
            <tr>
              <th className="sticky-col sticky-col-1  w-[40px] px-3 bg-white">
                    <input
                      type="checkbox"
                      className="custom-checkbox"
                        style={{
appearance: "none",
// width: "16px",
// height: "16px",
border: "1.5px solid #c0c0c0",
borderRadius: "4px",
cursor: "pointer",
backgroundImage: selectedinvoices.length === invoices.length &&
                        invoices.length > 0 ? "url('/checck.svg')" : "none",
backgroundPosition: "center",
backgroundRepeat: "no-repeat",
backgroundSize: "20px 20px",
}}
                      onChange={handleSelectAll}
                      checked={
                        selectedinvoices.length === invoices.length &&
                        invoices.length > 0
                      }
                    />
                  </th>

                  <th className="sticky-col sticky-col-2 min-w-[130px] px-1 file-size-of-heading">File Name</th>
               <th className="sticky-col sticky-col-3 min-w-[130px] px-3 file-size-of-heading bg-white z-10">
Type</th>
                  <th className="min-w-[180px] px-3 file-size-of-heading">Country</th>

                  <th className="min-w-[170px] px-3 file-size-of-heading">Issuing Authority</th>
                   {customFields.map((field, index) => (
  <th key={index} className="min-w-[120px] px-3 file-size-of-headings">
      <span className="inline-flex items-baseline gap-1">

    {field.field} <img
      src="/invoice-bulblogo-invoicee.svg"
      alt="Bullet Icon"
      className="ml-1 translate-y-[-2px]"  // slightly lifted
    />
      </span>
  </th>
))}
                  <th className="min-w-[130px] px-3 file-size-of-heading">ID Number</th>
                  <th className="min-w-[170px] px-3 file-size-of-heading">Name</th>
                  <th className="min-w-[130px] px-3 file-size-of-heading">DOB</th>
                  <th className="min-w-[130px] px-3 file-size-of-heading">Date of Issue</th>
                   <th className="min-w-[130px] px-3 file-size-of-heading">Date of Expiry</th>
                  <th className="min-w-[130px] px-3 file-size-of-heading">Actions</th>
                </tr>
              </thead>
              <tbody
                className={
                  currentinvoices.length > rowsPerPage ? "scrollable" : ""
                }
                style={{
                  overflowY:
                    currentinvoices.length > rowsPerPage ? "auto" : "hidden",
                  maxHeight: "400px",
                  backgroundColor: "#FFF",
                }}
              >
                {loading ? (
                  <tr>
                    <td colSpan="6" style={{ textAlign: "center" }}>
                      <Spinner />
                    </td>
                  </tr>
                ) : invoices.length > 0 ? (
                  currentinvoices.map((contract, index) => (
                    <tr
                      key={index}
                      ref={editContractId === contract.id ? editRowRef : null}
                      style={{
                        background:
                          hoveredRow === index ? "#F8F3FF" : "transparent",
                        boxShadow:
                          hoveredRow === index
                            ? "0px 2px 4px 0px rgba(0, 0, 0, 0.25)"
                            : "none",
                      }}
                      onMouseEnter={() => setHoveredRow(index)}
                      onMouseLeave={() => setHoveredRow(null)}
                                            className="h-[44px] border-b border-[rgba(0,0,0,0.10)] hover:bg-gray-50 transition"

                    >
<td className="sticky-col sticky-col-1 px-3 bg-white z-20">
                    
                           <input
type="checkbox"
className="custom-checkbox"
style={{
appearance: "none",
// width: "16px",
// height: "16px",
border: "1.5px solid #c0c0c0",
borderRadius: "4px",
cursor: "pointer",
backgroundImage: selectedinvoices.includes(contract.id)
  ? "url('/checck.svg')"
  : "none",
backgroundPosition: "center",
backgroundRepeat: "no-repeat",
backgroundSize: "20px 20px",
}}
checked={selectedinvoices.includes(contract.id)}
onChange={() =>
handleCheckboxChange(contract.id, contract.key)
}
/>
                      </td>

                      {editContractId === contract.id ? (
                        <>
                    <td className="sticky left-[40px]">
  <input
    type="text"
    value={invoice_name}
    onChange={(e) => setInvoiceName(e.target.value)}
    className="edit-contract-name-ocr"
    placeholder="Enter Invoice Name"
  />
</td>

               <td className="sticky-col sticky-col-3">
  <input
    type="text"
    value={editedContractData.details?.["Type"] || ""}
    onChange={(e) => handleEditChange("details.Type", e.target.value)}
    className="edit-contract-name-ocrs"
    placeholder="Enter Document Type"
  />
</td>
<td>
  <input
    type="text"
    value={editedContractData.details?.["Country"] || ""}
    onChange={(e) => handleEditChange("details.Country", e.target.value)}
    className="edit-contract-name-ocr"
    placeholder="Enter Country"
  />
</td>

<td>
  <input
    type="text"
    value={editedContractData.details?.["Issuing Authority"] || ""}
    onChange={(e) =>
      handleEditChange("details.Issuing Authority", e.target.value)
    }
    className="edit-contract-name-ocr"
    placeholder="Enter Issuing Authority"
  />
</td>

                           {customFields.map((fieldObj, index) => {
  const fieldKey = fieldObj.field;
  return (
    <td key={index} className="file-size-of-subheading">
      <input
        type="text"
        value={
          editedContractData.details?._custom_fields?.[fieldKey] || ""
        }
        onChange={(e) =>
          handleEditChange(
            `details._custom_fields.${fieldKey}`,
            e.target.value
          )
        }
        className="edit-contract"
      />
    </td>
  );
})}
<td>
  <input
    type="text"
    value={editedContractData.details?.["Id / Number"] || ""}
    onChange={(e) => handleEditChange("details.Id / Number", e.target.value)}
    className="edit-contract-name-ocr"
    placeholder="Enter ID / Number"
  />
</td>

<td>
  <input
    type="text"
    value={editedContractData.details?.["Name"] || ""}
    onChange={(e) => handleEditChange("details.Name", e.target.value)}
    className="edit-contract-name-ocr"
    placeholder="Enter Name"
  />
</td>

<td>
  <input
    type="date"
    value={editedContractData.details?.["DOB"] || ""}
    onChange={(e) => handleEditChange("details.DOB", e.target.value)}
    className="edit-contract-name-ocrs"
    placeholder="Select DOB"
  />
</td>

<td>
  <input
    type="date"
    value={editedContractData.details?.["Date of issue"] || ""}
    onChange={(e) => handleEditChange("details.Date of issue", e.target.value)}
    className="edit-contract-name-ocrs"
    placeholder="Select Date of Issue"
  />
</td>
<td>
  <input
    type="date"
    value={editedContractData.details?.["Date of expiry"] || ""}
    onChange={(e) => handleEditChange("details.Date of expiry", e.target.value)}
    className="edit-contract-name-ocrs"
    placeholder="Select Date of Expiry"
  />
</td>

                          
                         

                       
                          <td className="action-icons-contract">
                            <button
                              onClick={() =>
                                handleEditSave(contract.id, contract.key)
                              }
                              className="icon-button-contract"
                            >
                              <img
                                src="/save-icon-contracttable.svg"
                                alt="Save"
                                className="action-icon"
                              />
                            </button>
                            <button
                              onClick={() => setEditContractId(null)} 
                              className="icon-button-contract"
                            >
                              <img
                                src="/cancel-icon-contracttable.svg"
                                alt="Cancel"
                                className="action-icon"
                              />
                            </button>
                          </td>
                        </>
                      ) : (
                        <>
<td className="sticky left-[40px] z-[20] bg-white px-1 min-w-[130px]">
  <div className="relative group cursor-pointer text-[#B793ED] underline">
    <span className="truncate inline-block max-w-[120px] underline cursor-pointer"  onClick={() => setSelectedFilePreview(contract)}>
      {contract.name?.length > 25
        ? `${contract.name.slice(0, 40)}...${contract.name.slice(-5)}`
        : contract.name || "N/A"}
    </span>

    {/* Tooltip */}
    <div
      className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 hidden group-hover:flex px-3 py-1 text-sm bg-white text-gray-900 border border-gray-200 shadow-md rounded-md z-50 whitespace-nowrap"
    >
      {contract.name || "N/A"}
    </div>

    {/* Optional success bubble */}
 {renameSuccessRowId === contract.id && (
  <div className="fixed top-[400px] left-1/2 transform -translate-x-1/2 z-50 inline-flex items-center gap-2 px-4 py-2 h-[40px] rounded-md border border-gray-200 bg-white shadow-md text-sm text-gray-700">
    <img src="/green-icon-tick.svg" alt="Success" className="w-5 h-5" />
    <span>Your changes were applied</span>
  </div>
)}

  </div>
</td>


<td className="sticky-col sticky-col-3 px-3 file-size-of-subheading bg-white z-10">
                            {contract.details?.["Type"] || "N/A"}
                          </td>
                          <td className="px-3 file-size-of-subheading">
                            {contract.details?.["Country"] || "N/A"}
                          </td>
                          <td className="px-3 file-size-of-subheading">
                            {contract.details?.["Issuing Authority"] || "N/A"}
                          </td>
                                             {customFields.map((fieldObj, index) => {
  const fieldKey = fieldObj.field; // actual key used in _custom_fields
  const fieldValue = contract.details?._custom_fields?.[fieldKey] || "N/A";
  const isValid = fieldValue && fieldValue !== "null";

  return (
<td key={index} className="px-3 file-size-of-subheadin">
  <span
    className="text-[#B793ED] cursor-pointer inline-block max-w-[140px] truncate"
    onMouseEnter={(e) => {
      const rect = e.currentTarget.getBoundingClientRect();
      setCustomFieldPopup({
        visible: true,
        value: fieldValue,
        contractKey: contract.key,
        contractId: contract.id,
        x: rect.left + window.scrollX,
        y: rect.bottom + window.scrollY + 8,
      });
    }}
    onMouseLeave={(e) => {
      // Start timeout that allows user to move to popup
      setTimeout(() => {
        if (
          popupRef.current &&
          !popupRef.current.matches(':hover')
        ) {
          setCustomFieldPopup((prev) => ({ ...prev, visible: false }));
        }
      }, 150);
    }}
  >
    {fieldValue.length > 10
      ? `${fieldValue.slice(0, 10)}...`
      : fieldValue}
  </span>
  
</td>



  );
})}
                          <td className="px-3 file-size-of-subheading">
                            {contract.details?.["Id / Number"] || "N/A"}
                          </td>
                          <td className="px-3 file-size-of-subheading">
                            {contract.details?.["Name"] || "N/A"}
                          </td>
                          <td className="px-3 file-size-of-subheading">
                            {contract.details?.["DOB"] || "N/A"}
                          </td>
                          <td className="px-3 file-size-of-subheading">
                            {contract.details?.["Date of issue"] || "N/A"}
                          </td>
                          <td className="px-3 file-size-of-subheading">
                            {contract.details?.["Date of expiry"] || "N/A"}
                          </td>
                          
       
                 
                          <td className="px-3 ">
                            <img
                              src="./action.svg"
                              alt="Actions"
                              width="20"
                              height="20"
                          onClick={(e) => toggleActionMenu(index, e)}
                              style={{ cursor: "pointer" }}
                            />
                            {isActionMenuOpen === index && (
                              <div
className="action-menu"
style={{
  position: 'fixed',
  top: actionMenuPosition.openUpwards ? `${actionMenuPosition.top}px` : `${actionMenuPosition.top}px`,
  left: `${actionMenuPosition.left - 215}px`,
  transform: actionMenuPosition.openUpwards ? 'translateY(50%)' : 'none', // If openUpwards, shift the menu upward
  zIndex: 9999,
}}
                                  ref={actionMenuRef}
                              >
                                <div
                                  className="action-item"
                                  onMouseEnter={() => setHoveredAction("edit")}
                                  onMouseLeave={() => setHoveredAction(null)}
                                  onMouseDown={() => setClickedAction("edit")}
                                  onMouseUp={() => setClickedAction(null)}
                                  onClick={() => enableEdit(contract)}
                                  style={{
                                    color:
                                      clickedAction === "edit"
                                        ? "#C95EBE"
                                        : hoveredAction === "edit"
                                        ? "#C95EBE"
                                        : "#000",
                                    transition:
                                      "color 0.2s ease-in-out, background 0.2s ease-in-out",
                                    borderRadius: "8px",
                                    border:
                                      clickedAction === "edit" ||
                                      hoveredAction === "edit"
                                        ? "none"
                                        : "none",
                                    background:
                                      clickedAction === "edit" ||
                                      hoveredAction === "edit"
                                        ? "#FAF9F6"
                                        : "transparent",
                                    padding: "10px",
                                    cursor: "pointer",
                                    width:"8.2rem",
                                  }}
                                >
                                  <img
                                    src={
                                      clickedAction === "edit"
                                        ? "./edit-active-contract.svg"
                                        : hoveredAction === "edit"
                                        ? "./edit-active-contract.svg"
                                        : "./edit.svg"
                                    }
                                    alt="Edit Icon"
                                    className="action-icon"
                                  />
                                  <p>Edit</p>
                                </div>

                                <div
                                  className="action-item"
                                  onMouseEnter={() =>
                                    setHoveredAction("delete")
                                  }
                                  onMouseLeave={() => setHoveredAction(null)}
                                  onMouseDown={() => setClickedAction("delete")}
                                  onMouseUp={() => setClickedAction(null)}
                                  onClick={() => handleDelete(contract.id)}
                                  style={{
                                    color:
                                      clickedAction === "delete"
                                        ? "rgba(226, 25, 25, 0.75)"
                                        : hoveredAction === "delete"
                                        ? "rgba(226, 25, 25, 0.75)"
                                        : "#000",
                                    transition:
                                      "color 0.2s ease-in-out, background 0.2s ease-in-out",
                                    borderRadius: "8px",
                                    border:
                                      clickedAction === "delete" ||
                                      hoveredAction === "delete"
                                        ? "none"
                                        : "none",
                                    background:
                                      clickedAction === "delete" ||
                                      hoveredAction === "delete"
                                        ? "#FAF9F6"
                                        : "transparent",
                                    padding: "10px",
                                    cursor: "pointer",
                                    width:"8.2rem",
                                  }}
                                >
                                  <img
                                    src={
                                      clickedAction === "delete"
                                        ? "./delete-active-contract.svg"
                                        : hoveredAction === "delete"
                                        ? "./delete-active-contract.svg"
                                        : "./delete.svg"
                                    }
                                    alt="Delete Icon"
                                    className="action-icon"
                                  />
                                  <p>Delete</p>
                                </div>
                              </div>
                            )}
                          </td>
                        </>
                      )}
                    </tr>
                  ))
                    ) : (
                <tr className="h-[44px] text-center">
                    <td colSpan="7" className="py-6 text-black-400">
                      <img
                        src="/no-contracts.svg"
                        alt="No Data"
                        className="mx-auto mb-2"
                      />
                      <p className="text-[16px]">Looks like your table is empty!</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            </div>
            {invoices.length > 0 && (
              <div className="pagination-doc">
                 <div className="pagination-dropdown">
<p className="page-selector">{currentPage}</p>
</div>
                <p className="contentDown">of {totalPages} pages</p>
                <button
                  onClick={handlePreviousPage}
                  disabled={currentPage === 1}
                  style={{
                    cursor: currentPage === 1 ? "not-allowed" : "pointer",
                  }}
                >
                  <img
                    src="decrease.svg"
                    alt="Previous Page"
                    style={{ height: "12px", width: "12px" }}
                  />
                </button>
                <button
                  onClick={handleNextPage}
                  disabled={currentPage === totalPages}
                  style={{
                    cursor:
                      currentPage === totalPages ? "not-allowed" : "pointer",
                  }}
                >
                  <img
                    src="increase.svg"
                    alt="Next Page"
                    style={{ height: "12px", width: "12px" }}
                  />
                </button>
              </div>
            )}
          </div>
        </div>
        </div>

        {popupVisible && (
                    <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
            <div className="popup-box">
              <h2>{popupTitle}</h2>
              <p>{popupMessage}</p>
              <button onClick={closePopup} className="popup-close-button">
                Close
              </button>
            </div>
          </div>
        )}

            {confirmDeleteVisible && (
<div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
<div className="popup-box-delete">
  <h2>Are you sure you want to delete the selected spreadsheet?</h2>
  <p>
    {isBulkDelete
      ? "Once deleted, the selected item(s) will be permanently removed.This action cannot be undone."
      :  "Once deleted, the selected item(s) will be permanently removed.This action cannot be undone."}
  </p>
  <div
    style={{
      display: "flex",
      gap: "8px",
      justifyContent: "center",
      marginTop: "20px",
    }}
  >
   
    <button
      onClick={() => setConfirmDeleteVisible(false)}
      disabled={deleteInProgress}
      className="document-popup-close-delete"
    >
      Cancel
    </button>
     <button
      onClick={confirmDelete}
      disabled={deleteInProgress}
      className="document-popup-close-button"
    >
      {deleteInProgress ? "Deleting..." : "Delete"}
    </button>
  </div>
</div>
</div>
)}
        <UploadModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          onUploadSuccess={handleUploadSuccess}
          type={"ocr"}
          file={file}
        />

 <Filter_for_ocr
  isOpen={isFilterModalOpen}
  onClose={() => setIsFilterModalOpen(false)}
   onApply={(filteredResponse) => {
    // filteredResponse is { documents: [...] }
    setinvoices(filteredResponse.documents);   // ✅ Update table data
    setFilteredFiles(filteredResponse.documents); // optional
    setIsFilterApplied(true);
    setCurrentPage(1);  // reset to page 1
  }}
onClear={(cleared) => {
    setIsFilterApplied(false);  // ✅ Main toggle
    setinvoices(cleared?.documents || []);
    setCurrentPage(1);
  }}
  setIsFilterApplied={setIsFilterApplied}
  selectedFilters={selectedFilters}
  setSelectedFilters={setSelectedFilters}
/>



        {isCustomApplyFieldModal && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
            <div
              className="relative bg-white rounded-[12px] shadow-lg w-[417px] h-[366px] pt-[18px] pl-[24px] pr-[24px] pb-[24px]"
              style={{
                boxShadow:
                  '130px 189px 64px rgba(0, 0, 0, 0.00), 83px 121px 59px rgba(0, 0, 0, 0.01), 47px 68px 50px rgba(0, 0, 0, 0.05), 21px 30px 37px rgba(0, 0, 0, 0.09), 5px 8px 20px rgba(0, 0, 0, 0.10)',
              }}
            >
              <div className="flex justify-between items-center">
                <h2 className="apply-heading-cutom">
                  Apply Custom Field
                </h2>
                 <span className="text-[#8B55DD] bg-[rgba(139,85,221,0.08)] text-[14px] rounded px-3 py-1">
                  {selectedinvoices.length} Contracts selected
                </span>
                <span
                 onClick={() => setIsCustomApplyFiledModal(false)}
                  className="cursor-pointer text-xl"
                >
                  ×
                </span>
              </div>
        
             
        
              <div className="flex gap-8 mt-[20px] items-start">
          {/* Option 1: Select Existing */}
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="radio"
              checked={!isCreatingNew}
              onChange={() => setIsCreatingNew(false)}
              className="accent-[#7F56D9] w-4 h-4"
            />
            <span className="apply-dot-heading">
              Select from Existing Field
            </span>
          </label>
        
          {/* Option 2: Create New Field + (2/5 used) below it */}
          <label className="flex flex-col cursor-pointer">
            <div className="flex items-center gap-2">
              <input
                type="radio"
                checked={isCreatingNew}
                onChange={() => setIsCreatingNew(true)}
                className="accent-[#7F56D9] w-4 h-4"
              />
              <span className="apply-dot-heading">
                Create New Field
              </span>
            </div>
        <span className="text-xs text-[#999] ml-6">({customFields.length}/5 used)</span>
          </label>
        </div>
        
        
              {isCreatingNew ? (
                <>
                  <label className="apply-dot-heading">Field Name</label>
                  <input
                    className="apply-input-field pl-2 mt-1"
                    placeholder="Enter your field name here"
                    value={newFieldName}
                    onChange={(e) => setNewFieldName(e.target.value)}
                  />
                  <label className="apply-dot-heading mt-2">Extraction Prompt</label>
                  <textarea
                    className="apply-input-field-design-here pl-2 pt-1 pr-1 mt-1"
                    placeholder="Enter your Extraction Prompts here"
                    value={newPrompt}
                    onChange={(e) => setNewPrompt(e.target.value)}
                  />
                </>
              ) : (
                <>
                  <label className="apply-dot-heading">Choose Field</label>
              <CustomDropdown
          selected={selectedField}
          onSelect={setSelectedField}
          options={customFields.map((field) => field.field)}
        />
        
        
                </>
              )}
        
          <div className="absolute bottom-4 right-4 flex justify-end gap-3">
            <button
              className="cancel-apply-button-design"
              onClick={() => setIsCustomApplyFiledModal(false)}
            >
              Cancel
            </button>
            <button
              onClick={handleApplyField}
              className={`apply-apply-button ${
                isLoading ? 'bg-[#D081D9]' : 'bg-[#D081D9] hover:bg-[#C26ED2]'
              }`}
            >
              {isLoading ? (
                <span className="inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
              ) : isCreatingNew ? (
                'Create & Apply'
              ) : (
                'Apply Field'
              )}
            </button>
          </div>
            </div>
          </div>
        )}
            {isCustomFieldModalOpen && (
  <div className="custom-modal-overlay-inline show">
    <div className="custom-modal-content-custom active relative">
      <button
        className="close-modal-custom"
        onClick={() => setIsCustomFieldModalOpen(false)}
      >
        ×
      </button>

      <h2 className="custom-modal-title-custom">Custom Fields</h2>
      <p className="custom-modal-subtitle-custom">
        You can only create up to 5 custom fields per document.<br />
        Deleting a field won’t reset the limit.
      </p>

      <div className="custom-modal-tabs-custom">
        <button
          className={`manage-btn-custom ${selectedTab === "manage" ? "active" : ""}`}
          onClick={() => setSelectedTab("manage")}
        >
          {customFieldsLoading ? "Loading..." : `Manage Existing Fields (${customFields.length}/5)`}
        </button>
        <button
          className={`create-btn-custom ${selectedTab === "create" ? "active" : ""}`}
          onClick={() => setSelectedTab("create")}
        >
          Create New Field
        </button>
      </div>

      {selectedTab === "create" && (
        <>
          <label className="field-label-custom">
            Field name <img src="/bulb.svg" alt="Hint" className="label-icon-custom" />
          </label>
          <input
            type="text"
            className="input-field-custom"
            value={fieldName}
            onChange={(e) => setFieldName(e.target.value)}
            placeholder={
              isMaxFieldsReached
                ? "Maximum 3 fields allowed. Please delete one to add new."
                : "Enter your field name here"
            }
            disabled={isMaxFieldsReached}
          />
          <label className="field-label-custom">
            Extraction Prompt <img src="/bulb.svg" alt="Hint" className="label-icon-custom" />
          </label>
          <textarea
            className="textarea-field-custom"
            value={fieldPrompt}
            onChange={(e) => setFieldPrompt(e.target.value)}
            placeholder={
              isMaxFieldsReached
                ? "Cannot enter prompt. Maximum limit reached."
                : "Enter your Extraction Prompts here"
            }
            disabled={isMaxFieldsReached}
          />
          <button
            className={`add-field-btn-custom ${isFilled && !loadingAddField && !isMaxFieldsReached ? "active" : ""}`}
            onClick={handleAddField}
            disabled={loadingAddField || isMaxFieldsReached}
          >
            {loadingAddField ? "Adding..." : "Add Field"}
          </button>
        </>
      )}

      {selectedTab === "manage" && (
        <div>
          <div className="manage-fields-placeholder mt-[20px] max-h-[222px] overflow-y-auto mr-2">
            <div className="flex mt-2 gap-[60px]">
              <h2 className="field-name-custom">Field Name</h2>
              <h2 className="field-name-custom">Prompt</h2>
            </div>
            {customFields.length ? (
              customFields.map((field, index) => (
                <div key={index}>
                  <div className="flex items-start gap-[26px] mt-[12px]">
                    <p className="text-[#1A1A1A] text-sm font-medium w-[109px] whitespace-nowrap">
                      {field.field}
                    </p>
                    <p className="text-[#1A1A1A] text-sm w-[139px]">
                      {field.description}
                    </p>
                  <button
  className="button-red-custom-field"
  onClick={() => {
    setDeletingField(field.id);
    handleDeleteField(field.id);
  }}
  disabled={deletingField === field.id}
>
  {deletingField === field.id ? "Deleting" : "Delete"}
  <img src="/delete-icon-red.svg" alt="Delete" />
</button>

                  </div>
                  <div className="my-4 mt-[20px] border-[#EAEAEA] hr-line-divider"></div>
                </div>
              ))
            ) : (
              <p className="text-sm text-gray-500 ml-2 mt-3">No custom fields available.</p>
            )}
          </div>

          <button
            className="add-field-btn-custom-twos absolute bottom-4 right-4"
            
            onClick={async () => {
              await fetchinvoices(); // refresh table to show new field
              setIsCustomFieldModalOpen(false);
            }}
          >
            Done
          </button>
        </div>
      )}
    </div>
  </div>
)}
{customFieldPopup.visible && (
  <div
    ref={popupRef}
    className="fixed z-[9999] bg-white border border-gray-300 rounded-md shadow-md p-3"
    style={{
      top: `${customFieldPopup.y}px`,
      left: `${customFieldPopup.x}px`,
      maxWidth: "300px",
      width: "max-content",
      whiteSpace: "normal",
    }}
    onMouseEnter={() =>
      setCustomFieldPopup((prev) => ({ ...prev, visible: true }))
    }
    onMouseLeave={() =>
      setCustomFieldPopup((prev) => ({ ...prev, visible: false }))
    }
  >
    <p className="text-gray-800 text-sm font-medium break-words">
      {customFieldPopup.value.length > 80
        ? `${customFieldPopup.value.slice(0, 80)}...`
        : customFieldPopup.value}
    </p>
    {/* <button
      onClick={() =>
        handleViewMore(customFieldPopup.contractKey, customFieldPopup.contractId)
      }
      className="text-[#6F42C1] text-sm font-semibold underline mt-2 hover:text-[#4c2a8a]"
    >
      View More
    </button> */}
  </div>
)}

{selectedFilePreview && (
  <div
  className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm"
  onClick={() => setSelectedFilePreview(null)}
>

    <div
      className="bg-white rounded-lg shadow-lg w-[40vw] h-[55vh] overflow-hidden relative"
      onClick={(e) => e.stopPropagation()}
    >
      {/* Full Preview */}
      {selectedFilePreview.file_type === "pdf" ? (
        <embed
          src={selectedFilePreview.pdf_url}
          type="application/pdf"
          className="w-full h-full"
        />
      ) : (
        <img
          src={selectedFilePreview.pdf_url}
          alt={selectedFilePreview.name}
          className="w-full h-full object-contain"
        />
      )}
    </div>
  </div>
)}




      </div>
    </>
  );
};

export default ContractTable;